<!--
 * @Author: 张天昊
 * @Date: 2024-06-25 10:43:07
 * @LastEditTime: 2024-07-11 18:09:22
 * @LastEditors: 张天昊
 * @Description: 
 * @FilePath: /Mobile/src/pages/itineraryUniversal/components/PdfDownload.vue
-->
<script>
import { defineComponent, computed, ref, watch } from 'vue';
// import { useBlobDownload } from '@/composables/useBlobDownload';
import router from '@/router/routers';
import { openUrlByBrowser } from '@/utils/openUrlByBrowser';
import { createGetItineraryDetailPdfUrl } from '@/service';
import store from '@/store';

export default defineComponent({
  setup() {
    const route = router.currentRoute;
    const targetHref = ref('');

    const detailInfo = computed(
      () => store.state.itineraryUniversal.detailInfo.value
    );

    // const { downloadBlobAfterRequest } = useBlobDownload(
    //   getItineraryDetailPdf.bind(null, { id: route.params.id })
    // );
    function handleDownload() {
      // if (detailInfo.value?.itineraryInfoMessage.checkState === 2) {
      //   downloadBlobAfterRequest(`${route.params.id}.pdf`, 'application/pdf');
      // }
      openUrlByBrowser(targetHref.value, false, true);
    }

    watch(
      detailInfo,
      (detailInfoValue) => {
        if (
          detailInfoValue &&
          detailInfoValue.itineraryInfoMessage.checkState === 2
        ) {
          targetHref.value = createGetItineraryDetailPdfUrl({
            id: route.params.id
          });
        }
      },
      {
        immediate: true
      }
    );

    return {
      handleDownload,
      targetHref
    };
  }
});
</script>

<template>
  <div
    v-if="targetHref"
    class="inline-flex items-center text-14 leading-20 text-white van-haptics-feedback"
    @click="handleDownload"
  >
    <svg-icon
      pre-path="itineraryUniversal"
      name="ic-download"
      class="w-16 h-16 mr-6"
    />
    下载
  </div>
</template>
